// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tiktok-attributes-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.tiktok-attribute-dropdown__wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
    position: relative;
}

.tiktok-attribute-dropdown__label {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 14px;
}

.tiktok-attribute-dropdown__button {
    border: 1px solid #E4E7EC;
    border-radius: 8px;
    background-color: #FFFFFF;
    padding: 8px 12px;
    font-size: 14px;
    color: #344054;
    cursor: pointer;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    -webkit-user-select: none;
            user-select: none;
}

.tiktok-attribute-dropdown__button img {
    transition: transform 0.3s ease;
}

.tiktok-attribute-dropdown__button.opened img {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
}

.tiktok-attribute-dropdown__button.errored {
    border: 1px solid #FF3E00;
}

.tiktok-attribute-dropdown__content {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
    z-index: 10;
    -webkit-user-select: none;
            user-select: none;
    overflow: hidden;
}

.tiktok-attribute-dropdown__content-inner {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
}

.tiktok-attribute-dropdown__items {
    display: flex;
    flex-direction: column;
}

.tiktok-attribute-dropdown__item {
    padding: 8px 12px;
    font-size: 14px;
    color: #344054;
    cursor: pointer;
    border-radius: 8px;
}

.tiktok-attribute-dropdown__custom {
    display: flex;
    align-items: center;
    gap: 8px;
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
}

.tiktok-attribute-dropdown__input {
    width: 100%;
    height: 40px;
    padding: 12px;
    font-size: 14px;
    color: #344054;
    border-top: 1px solid #E4E7EC;
}

.tiktok-attribute-dropdown__custom-apply {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    background-color: #4db8ff;
    padding: 0px 12px;
    border-radius: 8px;
    font-size: 14px;
    color: #344054;
    cursor: pointer;
    height: 32px;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
}

.tiktok-attributes-list__buttons {
    display: flex;
    justify-content: space-between;
    gap: 8px;
}

.tiktok-verification__current-product {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 8px;
    border: 1px solid #E4E7EC;
    border-radius: 8px;
    background-color: #FFFFFF;
}

.tiktok-verification__current-product-label {
    font-size: 14px;
    color: #344054;
}

.tiktok-verification__current-product-info {
    display: flex;
    align-items: center;
    gap: 8px;
}

.tiktok-verification__current-product-info-text {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.tiktok-verification__current-product-info-title {
    font-size: 12px;
    color: #4db8ff;
    font-weight: 500;
}

.empty-image-box {
    width: 50px;
    height: 50px;
    background-color: #E4E7EC;
}

.tiktok-attributes__upload-size-chart {
    display: flex;
    flex-direction: column;
    gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/TikTokProductVerification/TikTokProductVerification.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;IAClB,2CAA2C;IAC3C,WAAW;IACX,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ","sourcesContent":[".tiktok-attributes-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.tiktok-attribute-dropdown__wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    position: relative;\n}\n\n.tiktok-attribute-dropdown__label {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    font-size: 14px;\n}\n\n.tiktok-attribute-dropdown__button {\n    border: 1px solid #E4E7EC;\n    border-radius: 8px;\n    background-color: #FFFFFF;\n    padding: 8px 12px;\n    font-size: 14px;\n    color: #344054;\n    cursor: pointer;\n    min-height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    user-select: none;\n}\n\n.tiktok-attribute-dropdown__button img {\n    transition: transform 0.3s ease;\n}\n\n.tiktok-attribute-dropdown__button.opened img {\n    transform: rotate(180deg);\n    transition: transform 0.3s ease;\n}\n\n.tiktok-attribute-dropdown__button.errored {\n    border: 1px solid #FF3E00;\n}\n\n.tiktok-attribute-dropdown__content {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background-color: #FFFFFF;\n    border-radius: 8px;\n    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);\n    z-index: 10;\n    user-select: none;\n    overflow: hidden;\n}\n\n.tiktok-attribute-dropdown__content-inner {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    width: 100%;\n    max-height: 200px;\n    overflow-y: auto;\n}\n\n.tiktok-attribute-dropdown__items {\n    display: flex;\n    flex-direction: column;\n}\n\n.tiktok-attribute-dropdown__item {\n    padding: 8px 12px;\n    font-size: 14px;\n    color: #344054;\n    cursor: pointer;\n    border-radius: 8px;\n}\n\n.tiktok-attribute-dropdown__custom {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    position: sticky;\n    bottom: 0;\n    left: 0;\n    right: 0;\n}\n\n.tiktok-attribute-dropdown__input {\n    width: 100%;\n    height: 40px;\n    padding: 12px;\n    font-size: 14px;\n    color: #344054;\n    border-top: 1px solid #E4E7EC;\n}\n\n.tiktok-attribute-dropdown__custom-apply {\n    position: absolute;\n    right: 4px;\n    top: 50%;\n    transform: translateY(-50%);\n    background-color: #4db8ff;\n    padding: 0px 12px;\n    border-radius: 8px;\n    font-size: 14px;\n    color: #344054;\n    cursor: pointer;\n    height: 32px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #FFFFFF;\n}\n\n.tiktok-attributes-list__buttons {\n    display: flex;\n    justify-content: space-between;\n    gap: 8px;\n}\n\n.tiktok-verification__current-product {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    padding: 8px;\n    border: 1px solid #E4E7EC;\n    border-radius: 8px;\n    background-color: #FFFFFF;\n}\n\n.tiktok-verification__current-product-label {\n    font-size: 14px;\n    color: #344054;\n}\n\n.tiktok-verification__current-product-info {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.tiktok-verification__current-product-info-text {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.tiktok-verification__current-product-info-title {\n    font-size: 12px;\n    color: #4db8ff;\n    font-weight: 500;\n}\n\n.empty-image-box {\n    width: 50px;\n    height: 50px;\n    background-color: #E4E7EC;\n}\n\n.tiktok-attributes__upload-size-chart {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
